import { render, staticRenderFns } from "./TopupResult.vue?vue&type=template&id=702c696e&scoped=true&"
import script from "./TopupResult.vue?vue&type=script&lang=js&"
export * from "./TopupResult.vue?vue&type=script&lang=js&"
import style0 from "./TopupResult.vue?vue&type=style&index=0&id=702c696e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702c696e",
  null
  
)

export default component.exports